// extracted by mini-css-extract-plugin
export default {"Player":"GameRenderer_Player__rrg2j","Bottle":"GameRenderer_Bottle__GtB3q","NextCapsule":"GameRenderer_NextCapsule__+wCFU","Info":"GameRenderer_Info__AQv8x"};